// extracted by mini-css-extract-plugin
module.exports = {"translation":"Translation_translation__37nRm","translate":"Translation_translate__21YQM","actions":"Translation_actions__2Ng7U"};